import { ApplicationElement, html } from '../application_element/element.js';
import style from './style.lit.css';

/**
 * General progress bar
 *
 * @prop percent - Percentage of filled progress bar ( number, default: 0 )
 */
export default class ProgressBar extends ApplicationElement {
  static properties = {
    percent: { type: Number },
  };

  static styles = [ApplicationElement.styles, style];

  render() {
    return html`
      <div
        role="progressbar"
        title="progressbar"
        style="width: ${this.percent}%"></div>
    `;
  }
}

customElements.get('ef-progress-bar') ||
  customElements.define('ef-progress-bar', ProgressBar);
